import { Country } from "../country/country"
import {Type} from "class-transformer"

export class ShipmentParcelShop {
  pudoId: string
  name: string
  name2: string
  maxparcel: number
  maxweight: number
  carrierDepot: string
  @Type(() => Country)
  addressCountry: Country
  street: string
  propertyNumber: string
  address2: string
  zipCode: string
  town: string

  constructor(
    pudoId: string,
    name: string,
    name2: string,
    maxparcel: number,
    maxweight: number,
    carrierDepot: string,
    addressCountry: Country,
    street: string,
    propertyNumber: string,
    address2: string,
    zipCode: string,
    town: string
  ) {
    this.pudoId = pudoId
    this.name = name
    this.name2 = name2
    this.maxparcel = maxparcel
    this.maxweight = maxweight
    this.carrierDepot = carrierDepot
    this.addressCountry = addressCountry
    this.street = street
    this.propertyNumber = propertyNumber
    this.address2 = address2
    this.zipCode = zipCode
    this.town = town
  }

  convertWeight(): string {
    if (exists(this.maxweight)) {
      return (this.maxweight / 100).toString() + " kg"
    } else {
      return "n/a"
    }
  }

  convertMaxParcels(): string {
    if (exists(this.maxparcel) && this.maxparcel > 0) {
        return this.maxparcel.toString()
    } else {
      return "n/a"
    }
  }

  hasSecondaryAddress(): boolean {
    return (exists(this.address2) && this.address2.length > 0)
  }
}
